const OnboardingRoutes = {
  OnboardingOptions: 'OnboardingOptions',
  OnboardingOptionsPublic: 'OnboardingOptionsPublic',
  CreateOrganization: 'CreateOrganization',
  OnboardingStatus: 'OnboardingStatus',
  OnboardingStatusPublic: 'OnboardingStatusPublic'
};

export default OnboardingRoutes;
